import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FiPlus, FiEdit2, FiTrash2, FiCalendar } from "react-icons/fi";
import leaveService from "../../services/leaveService";

export default function LeaveTypeList() {
    const navigate = useNavigate();
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        leaveService
            .getLeaveTypes()
            .then((res) => setLeaveTypes(res.data?.data ?? res.data ?? []))
            .catch((err) => toast.error(err.response?.data?.message || err.message))
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    const handleDelete = async (leaveType) => {
        if (!window.confirm(`Delete "${leaveType.name}"? This only works if no applications reference it.`)) return;
        try {
            await leaveService.deleteLeaveType(leaveType._id);
            toast.success("Leave type deleted");
            load();
        } catch (err) {
            toast.error(err.response?.data?.message || err.message);
        }
    };

    if (loading) return <div className="loading-center"><div className="spinner" />Loading leave types…</div>;

    return (
        <div>
            <div className="page-header">
                <div>
                    <h1 className="page-title"><FiCalendar size={20} style={{ marginRight: 8, verticalAlign: -3 }} />Leave Types</h1>
                    <p className="page-subtitle">{leaveTypes.length} leave type{leaveTypes.length !== 1 ? "s" : ""} configured</p>
                </div>
                <button className="btn btn-primary" onClick={() => navigate("/leave-types/new")}>
                    <FiPlus size={14} /> Add Leave Type
                </button>
            </div>

            {leaveTypes.length === 0 ? (
                <div className="card">
                    <div className="card-body" style={{ textAlign: "center", color: "var(--text-muted)", padding: "2rem" }}>
                        No leave types configured yet.
                    </div>
                </div>
            ) : (
                <div className="card">
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Code</th>
                                    <th>Allowed / Year</th>
                                    <th>Applies To</th>
                                    <th>Attendance Status</th>
                                    <th>Status</th>
                                    <th style={{ textAlign: "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {leaveTypes.map((lt) => (
                                    <tr key={lt._id}>
                                        <td style={{ fontWeight: 600 }}>{lt.name}</td>
                                        <td>{lt.code || "—"}</td>
                                        <td>{lt.allowedPerYear} day{lt.allowedPerYear !== 1 ? "s" : ""}</td>
                                        <td>{(lt.applicableCategories || []).join(", ") || "—"}</td>
                                        <td>{lt.attendanceStatus}</td>
                                        <td>
                                            <span style={{
                                                fontSize: 11.5, fontWeight: 600, padding: "2px 8px", borderRadius: 99,
                                                background: lt.isActive ? "#dcfce7" : "#f1f5f9",
                                                color: lt.isActive ? "#15803d" : "#64748b",
                                            }}>
                                                {lt.isActive ? "Active" : "Inactive"}
                                            </span>
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            <button className="btn btn-outline btn-sm" onClick={() => navigate(`/leave-types/${lt._id}/edit`)} style={{ marginRight: 6 }}>
                                                <FiEdit2 size={12} /> Edit
                                            </button>
                                            <button className="btn btn-outline btn-sm" onClick={() => handleDelete(lt)} style={{ color: "#dc2626" }}>
                                                <FiTrash2 size={12} /> Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
}